import RescheduleLessons from './RescheduleLessons';

export default RescheduleLessons;
